// form-fields
const UploadFiles = (function UploadFiles() {
	let fileList = [];
	let allowedFileTypes = ['.pdf', '.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.xml', '.bmp', '.gif', '.jpg', '.jpeg', '.png', '.wav', '.mp3', '.mp4', '.mpg', '.mpeg', '.mov', '.avi', '.rar', '.zip', '.txt', '.rtf'];
	
	function attachEvents() {
		let fileInput = document.querySelector('.custom-file-input');
		fileInput && fileInput.addEventListener('change', function (e) {
			fileList = [];
			for (let i = 0; i < fileInput.files.length; i++) {
				fileList.push(fileInput.files[i]);
			}
			renderFileList();
		});
		document.querySelector('.uploaded-files-container') && document.querySelector('.uploaded-files-container').addEventListener("click", function(e) {
			let fileIndex = e.target.closest('.remove-uploaded-item').getAttribute('data-fileindex');
			fileList.splice(fileIndex, 1);
			renderFileList();
		})
		if (fileList.length > 0) {
			renderFileList();
		}
	}
	
	function renderFileList() {
		document.querySelector('.uploaded-files-container').innerHTML = '';
		fileList.forEach(function (file, index) {
			let totalFileBytes = file.size;
			let fileSize;
			
			if (totalFileBytes < 1000000) {
				fileSize = Math.floor(totalFileBytes / 1000) + ' Kb';
			} else {
				fileSize = Math.floor(totalFileBytes / 1000000) + ' Mb';  
			}
			
			let fileDisplayEl = document.createElement('div');
			fileDisplayEl.classList.add("uploaded-file");
			let isFileAllowed = allowedFileTypes.includes(getFileExtension(file.name));
			
			fileDisplayEl.innerHTML = `
			<div class="uploaded-file-info">
			<span class="${isFileAllowed ? 'icon-circle-check' : 'icon-error'}" role="presentation"></span>
			<span class="file-name">${file.name}</span>
			<span class="file-size">${fileSize}</span>
			<a href="javascript:void(0)" class="remove-uploaded-item" data-fileindex=${index}>
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
			<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
			</svg>
			</a>
			</div>
			${!isFileAllowed ? '<div class="file-not-supported">File type not supported</div>' : ''}
			`;
			document.querySelector('.uploaded-files-container').appendChild(fileDisplayEl);
		});
	};
	
	function getFileExtension(fileString) {
		return fileString.slice(fileString.lastIndexOf("."));
	}
	
	attachEvents();
	
	return {
		attachEvents: attachEvents
	}
})();

const floatingLabel = (function floatingLabel() {
	let formContainer = document.querySelector('.cmpt-form-wrapper') && document.querySelector('.cmpt-form-wrapper').parentNode;
	
	function setFormObserver(container) {
		let observer = new MutationObserver(function(mutations) {
			checkFields();
			UploadFiles.attachEvents();
		})
		let config = { childList: true };
		
		observer.observe(container, config);
	}
	
	const handleFocus = (e) => {
		const target = e.target;
		target.closest('.form-holder').classList.add('active');
	};
	
	const handleBlur = (e) => {
		const target = e.target;
		if(!target.value) {
			target.closest('.form-holder').classList.remove('active');
		}
	};
	
	const checkFields = () => {
		document.querySelectorAll('.form-holder').forEach((element) => {
			if (element.querySelector('input[type="text"], input[type="email"], input[type="password"], input[type="tel"]') && element.querySelector('input[type="text"], input[type="email"], input[type="password"], input[type="tel"]').value) {                
				element.classList.add('active');
			}      
			
			bindEvents(element);
		});
	}
	
	const bindEvents = (element) => {
		const floatField = element.querySelector('input[type="text"], input[type="email"], input[type="password"], input[type="tel"]');
		if (floatField) {
			floatField.addEventListener('focus', handleFocus);
			floatField.addEventListener('blur', handleBlur);    
		}
	};
	
	const init = () => {
		if (formContainer) {
			setFormObserver(formContainer);
		}
		checkFields();
	};
	
	init();
	
	return {
		init: init,
		checkFields: checkFields
	}
})();

// Clutch form validation


